import { hasOwnProperty } from '../../functions/hasOwnProperty';
import { IDjangoApi1License, ILicenseWebRight } from './Licenses';

export interface IDjangoProjectSummary {
    id: number;
    name: string;
    user: number;
    created: string;
    licenses: number[];
    family_count: number;
    style_count: number;
    styles: number[];
}

export interface IProjectSummary extends IDjangoProjectSummary {
    date: Date;
}

export function isIProjectSummary(obj: unknown): obj is IProjectSummary {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'id' in obj &&
        'name' in obj &&
        'user' in obj &&
        'created' in obj &&
        'family_count' in obj &&
        'style_count' in obj &&
        'styles' in obj &&
        'date' in obj &&
        hasOwnProperty(obj, 'licenses') &&
        Array.isArray(obj.licenses) &&
        (obj.licenses.length == 0 || typeof obj.licenses[0] === 'number')
    );
}
export function transformIDjangoProjectSummaryToIProjectSummary(
    project: IDjangoProjectSummary
): IProjectSummary {
    const date = new Date(project.created);
    return { ...project, date };
}

export interface IDjangoApi1ProjectLicense extends IDjangoApi1License {
    fontRights: {
        web: ILicenseWebRight;
    };
}

export interface IDjangoProject
    extends Omit<
        IDjangoProjectSummary,
        'licenses' | 'family_count' | 'style_count' | 'styles'
    > {
    domains: string[];
    stylesheet_url: string;
    created: string;
    licenses: IDjangoApi1ProjectLicense[];
}

export interface IProject extends IDjangoProject {
    date: Date;
}

export function isIProject(obj: unknown): obj is IProject {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'id' in obj &&
        'name' in obj &&
        'user' in obj &&
        'created' in obj &&
        'domains' in obj &&
        'stylesheet_url' in obj &&
        'date' in obj &&
        hasOwnProperty(obj, 'licenses') &&
        Array.isArray(obj.licenses) &&
        (obj.licenses.length == 0 ||
            (typeof obj.licenses[0] === 'object' &&
                'fontRights' in obj.licenses[0] &&
                'web' in obj.licenses[0].fontRights))
    );
}

export function transformIDjangoProjectToIProject(
    project: IDjangoProject
): IProject {
    const date = new Date(project.created);
    return { ...project, date };
}

export interface IProjectNew extends Omit<IProject, 'id'> {
    id?: number;
}

export interface IDjangoProjectNew extends Omit<IProjectNew, 'licenses'> {
    licenses: ILicenseWebRight[];
}

export function transformIProjectNewToIDjangoProjectNew(
    project: IProjectNew
): IDjangoProjectNew {
    return {
        ...project,
        licenses: project.licenses.map((license) => license.fontRights.web),
    };
}

export interface IProjectFilters {
    name?: string;
    date?: {
        start: {
            month: string;
            year: number;
        };
        end: {
            month: string;
            year: number;
        };
    };
}
